import { render, staticRenderFns } from "./WritingPhase.vue?vue&type=template&id=a1fe57c4&scoped=true&"
import script from "./WritingPhase.vue?vue&type=script&lang=js&"
export * from "./WritingPhase.vue?vue&type=script&lang=js&"
import style0 from "./WritingPhase.vue?vue&type=style&index=0&id=a1fe57c4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fe57c4",
  null
  
)

export default component.exports